<script>
import {  common } from '@/mixins/common';
import { PostApiWithAuthorizationAction } from '../../../helpers/apiActions';

export default {
  name: 'AddMoreItemToShowDialog',
  components: {},
  props: {
    data: {
      type: Object,
      required: true,
      default() {
        return {
          count: 0,
          id: 0
        }
      }
    }
  },
  data() {
      var validateCount = (rule, value, callback) => {
        if (!value) {
          return callback(new Error('Count field is required.'));
        }
        setTimeout(() => {
          if (!Number.isInteger(value)) {
            callback(new Error('Count field is required.'));
          } else {
            if (value > 500) {
              callback(new Error('Count can not exceed 500.'));
            } else {
              callback();
            }
          }
        }, 1000);
      };
    return {
      displayDialog: false,
      error: '',
      form: {
        count: ''
      },
      rules: {
        count: [
           { validator: validateCount, trigger: 'change' }
        ]
      }
    }
  },
  mixins: [
    common
  ],
  mounted() {
    const _vm = this
    _vm.$root.$on("open-add-more-item-dialog", () => {
      _vm.displayDialog = !_vm.displayDialog
    });
  },
  methods: {
    submitForm () {
      let _vm = this
      _vm.$refs.formContainer.validate((valid) => {
        // eslint-disable-next-line
        console.log(valid)
        if (valid) {
          PostApiWithAuthorizationAction("admin/products/live-show/add-items-to-show/" + _vm.data.id, _vm.form)
          .then(res => {
            if (res.status == 'success') {
              window.location.reload()
            } else {
              _vm.error = res.message
            }
          });
        }
      });
    }
  },
  computed: {},
  watch: {
    'form.count': function() {
      this.error = ''
    },
  }
}
</script>

<template>
    <el-dialog
      custom-class="el-dialog-bs-info"
      :visible.sync="displayDialog"
      width="40%">
      <span slot="title"><h5><i class="fas fa-qrcode"></i> ADD ITEMS</h5></span>
      <el-form
        :model="form"
        ref="formContainer"
        @submit.native.prevent="submitForm"
        id="identifierForm">
        <div class="my-2 mb-3">
          <el-form-item
            class="mb-1"
            :rules="rules.count"
            prop="count">
            <el-input
              type="number"
              ref="drawerPrimaryField"
              placeholder="How many items you want to add ?"
              v-model.number="form.count"
              class="input-with-select">
            </el-input>
            <div class="el-form-item__error">{{ error }}</div>
          </el-form-item>
        </div>
      </el-form>
      <span slot="footer" class="dialog-footer text-right">
        <el-button native-type="submit" type="danger" @click="submitForm">SUBMIT</el-button>
      </span>
    </el-dialog>
</template>